// Factor de una presentación — pos-graciela-api/docs/SPEC_PRESENTACIONES_EN_COMPRAS_v0.1.md
// §11, RN-7: toda presentación equivale a unidades ENTERAS del producto (una
// «media caja» de 12 son 6 unidades, no 0,5 cajas). Mismos textos que el API
// (src/domain/presentacionFactor.js), para avisar antes de guardar.

export const esFactorEntero = (valor) => Number.isInteger(Number(valor));

const cantidadTexto = (valor) => Number(valor).toLocaleString('es-PY', { maximumFractionDigits: 3 });

/** Alta o edición de una presentación con un componente no entero (RF-9). */
export const mensajeFactorNoEntero = ({ presentacion, cantidad, producto }) =>
  `«${presentacion}» tiene ${cantidadTexto(cantidad)} unidades de «${producto}». `
  + 'Una presentación tiene que traer unidades enteras del producto. '
  + 'Por ejemplo, si la caja trae 12, una media caja son 6: cargá 6. '
  + 'Si el producto se compra suelto, cargalo por unidad sin presentación.';

/** Compra con una presentación no entera que ya existía (RN-5). */
export const mensajeCompraPorUnidad = ({ presentacion }) =>
  `«${presentacion}» no equivale a unidades enteras del producto: cargá el producto por unidad, `
  + 'con la cantidad de unidades que llegaron.';

// Etapa 2, RF-12 (H-4): la cantidad de presentaciones puede ser decimal, pero
// cantidad × factor tiene que dar unidades enteras. Redondeado a 3 decimales:
// 0,00015 × 5000 da 0,7499999… y tiene que leerse 0,75. Igual que el API.
export const unidadesDe = (cantidad, factor) => Math.round(Number(cantidad) * Number(factor) * 1000) / 1000;

export const unidadesEnteras = (cantidad, factor) => Number.isInteger(unidadesDe(cantidad, factor));

const cantidadEscrita = (valor) => Number(valor).toLocaleString('es-PY', { maximumFractionDigits: 6 });

/** Compra por presentación que no da unidades enteras (RF-12). */
export const mensajeUnidadesNoEnteras = ({ presentacion, producto, cantidad, factor }) =>
  `${cantidadEscrita(cantidad)} «${presentacion}» son ${cantidadTexto(unidadesDe(cantidad, factor))} unidades de «${producto}». `
  + `La compra tiene que dar unidades enteras: revisá la cantidad (1 «${presentacion}» = ${cantidadTexto(factor)} unidades) `
  + 'o cargá el producto por unidad.';
